module.exports = __webpack_public_path__ + "img/Group 885two.129ed023.svg";